import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = {
  key: 0,
  class: "dropzone"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "file_upload"),
  /*#__PURE__*/_createElementVNode("span", null, "Datei(en) hier ablegen")
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modes" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "chat", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Antworten", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "note", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Notiz", -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "input-wrapper" }
const _hoisted_13 = { class: "actions" }
const _hoisted_14 = { class: "attachments" }
const _hoisted_15 = { class: "file-input" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "attach_file", -1)
const _hoisted_17 = { class: "send" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_indicator_circular = _resolveComponent("md-progress-indicator-circular")!
  const _component_transition_fade = _resolveComponent("transition-fade")!
  const _component_chat_input_answers = _resolveComponent("chat-input-answers")!
  const _component_chat_input_assign_overlay = _resolveComponent("chat-input-assign-overlay")!
  const _component_chat_input_template_overlay = _resolveComponent("chat-input-template-overlay")!
  const _component_editor_content = _resolveComponent("editor-content")!
  const _component_md_content_editable = _resolveComponent("md-content-editable")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_template_select_modal = _resolveComponent("template-select-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: "chat-input-field-wrapper",
    onDragover: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.dropzoneVisible = true), ["prevent"])),
    onDragleave: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.dropzoneVisible = false), ["stop"])),
    onDrop: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFilesDrop && _ctx.onFilesDrop(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["chat-input-field", [_ctx.mode]])
    }, [
      _createVNode(_component_transition_fade, null, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_md_progress_indicator_circular)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_transition_fade, null, {
        default: _withCtx(() => [
          (_ctx.isAnswerSearchActive)
            ? (_openBlock(), _createBlock(_component_chat_input_answers, {
                key: 0,
                query: _ctx.message,
                onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.message = $event))
              }, null, 8, ["query"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_transition_fade, null, {
        default: _withCtx(() => [
          (!_ctx.isAssigned && _ctx.mode !== 'note')
            ? (_openBlock(), _createBlock(_component_chat_input_assign_overlay, {
                key: 0,
                conversation: _ctx.conversation
              }, null, 8, ["conversation"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_transition_fade, null, {
        default: _withCtx(() => [
          (_ctx.dropzoneVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.isAssigned && _ctx.isTemplateRequired && _ctx.mode !== 'note')
        ? (_openBlock(), _createBlock(_component_chat_input_template_overlay, {
            key: 0,
            conversation: _ctx.conversation,
            onOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.templateSelectModal.open()))
          }, null, 8, ["conversation"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["mode", { active: _ctx.mode === 'reply' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mode = 'reply'))
        }, _hoisted_8, 2),
        _createElementVNode("div", {
          class: _normalizeClass(["mode", { active: _ctx.mode === 'note' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mode = 'note'))
        }, _hoisted_11, 2)
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.mode === 'note')
          ? (_openBlock(), _createBlock(_component_editor_content, {
              key: 0,
              editor: _ctx.editor
            }, null, 8, ["editor"]))
          : (_openBlock(), _createBlock(_component_md_content_editable, {
              key: 1,
              modelValue: _ctx.message,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.message) = $event)),
              text: _ctx.message,
              "onUpdate:text": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.message) = $event)),
              rows: 2,
              multiline: true,
              border: false,
              error: false,
              ref: "input",
              onKeydown: _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (_ctx.send()), ["ctrl"]), ["enter"])),
              placeholder: 
            _ctx.mode !== 'note'
              ? 'Schreibe eine Nachricht...'
              : 'Schreibe eine Notiz...'
          
            }, null, 8, ["modelValue", "text", "placeholder"]))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("label", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("input", {
              type: "file",
              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onAttachmentSelect && _ctx.onAttachmentSelect(...args))),
              multiple: ""
            }, null, 32)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_md_button, {
            variant: "icon",
            mode: "icon_small",
            icon: _ctx.mode !== 'note' ? 'send' : 'save',
            grey: _ctx.mode === 'note',
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.send()))
          }, null, 8, ["icon", "grey"])
        ])
      ])
    ], 2),
    _createVNode(_component_template_select_modal, { ref: "templateSelectModal" }, null, 512)
  ], 32))
}